import {HttpHeaders} from '@angular/common/http';
import {
  Component,
  Configuration,
  CreateServiceResponse,
  GetComponentResponse,
  GetServiceResponse,
  GetServicesResponse,
  GetServiceTemplatesResponse,
  Response,
  SearchServiceResponse,
  ServiceAdministrationServiceInterface
} from '@gt-api';
import {EMPTY, Observable, of} from 'rxjs';
import {ServiceDataMock} from '@testhelper/mocks/service-data.mock';

export class ServiceAdministrationServiceStub implements ServiceAdministrationServiceInterface {
  defaultHeaders: HttpHeaders = new HttpHeaders();
  configuration: Configuration;

  addComponent1(nmbr: string, body?: Component, extraHttpRequestParams?: any): Observable<Response> {
    return of({code: 200} as Response);
  }

  createService2(nmbr: string, templateId: number, organization?: string, name?: string): Observable<Response> {
    return EMPTY;
  }

  createService1(templateId: number, organization?: string, name?: string): Observable<CreateServiceResponse> {
    return EMPTY;
  }

  deleteService1(nmbr: string, organization?: string): Observable<Response> {
    return EMPTY;
  }

  editComponent1(
    serviceNumber: string,
    componentId: number,
    organization?: string,
    login?: string,
    body?: Component
  ): Observable<Response> {
    return EMPTY;
  }

  editServiceName1(nmbr: string, organization?: string, name?: string): Observable<Response> {
    return EMPTY;
  }

  getComponent1(serviceNumber: string, componentId: number, organization?: string, login?: string): Observable<GetComponentResponse> {
    return EMPTY;
  }

  getService1(serviceNumber: string, organization?: string, login?: string): Observable<GetServiceResponse> {
    return of({
      code: 200,
      service: ServiceDataMock.getServiceData().find(data => data.number === serviceNumber) ?? ServiceDataMock.getServiceData()[0]
    });
  }

  getServiceTemplates1(organization?: string, login?: string): Observable<GetServiceTemplatesResponse> {
    return EMPTY;
  }

  removeComponent1(nmbr: string, componentId: number, extraHttpRequestParams?: any): Observable<Response> {
    return of({code: 200} as Response);
  }

  searchService1(
    organization?: string,
    login?: string,
    serviceNumber?: string,
    serviceOrganization?: string,
    serviceName?: string,
    serviceProvider?: string,
    entriesPerPage?: number,
    page?: number
  ): Observable<SearchServiceResponse> {
    return of({code: 200, services: [{number: '1', name: '', organization: 'test', provider: 'test'}]});
  }

  getInboundServices1(organization?: string, login?: string): Observable<GetServicesResponse> {
    return of({code: 200, services: []});
  }

  getOutboundServices1(organization?: string, login?: string): Observable<GetServicesResponse> {
    return of({code: 200, services: []});
  }
}
